import { AngularSvgIconModule } from 'angular-svg-icon';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import * as moment from 'moment';
import { utc, duration } from 'moment';
import '@angular/forms';
import debug from 'debug';
import { NotificationService } from '@progress/kendo-angular-notification';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { BsModalRef, BsModalService, BsDropdownModule } from 'ngx-bootstrap';
import { BsModalService as BsModalService$1 } from 'ngx-bootstrap/modal/bs-modal.service';
import { utils, writeFile } from 'xlsx';
import { __read, __values, __awaiter, __generator, __extends } from 'tslib';
import { Observable as Observable$1 } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { HttpResponse, HttpClient, HttpClientModule, HttpErrorResponse } from '@angular/common/http';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs/Rx';
import { Router, convertToParamMap } from '@angular/router';
import { from, fromEvent, throwError, ReplaySubject } from 'rxjs';
import { Pipe, Injectable, NgModule, Inject, Component, Input, Directive, EventEmitter, defineInjectable, inject, ElementRef, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var HashtagsPipe = /** @class */ (function () {
    function HashtagsPipe() {
    }
    /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    HashtagsPipe.prototype.transform = /**
     * @param {?} value
     * @param {?=} args
     * @return {?}
     */
    function (value, args) {
        return value.replace(/#[a-zA-Z0-9\-]{1,25}/g, '<span class="hashtag">$&</span>');
    };
    HashtagsPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'hashtags'
                },] }
    ];
    return HashtagsPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Nl2brPipe = /** @class */ (function () {
    function Nl2brPipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    Nl2brPipe.prototype.transform = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return value.replace(/\n/g, '<br>');
    };
    Nl2brPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'nl2br'
                },] }
    ];
    return Nl2brPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment$1 = moment;
var RelativeTimePipe = /** @class */ (function () {
    function RelativeTimePipe() {
    }
    /**
     * @param {?} datetime
     * @return {?}
     */
    RelativeTimePipe.prototype.transform = /**
     * @param {?} datetime
     * @return {?}
     */
    function (datetime) {
        if (!datetime) {
            return '';
        }
        /** @type {?} */
        var timePoint = moment$1(datetime);
        /** @type {?} */
        var millisecondsDiff = -timePoint.diff(moment$1());
        if (millisecondsDiff > 4 * 3600 * 1000) {
            return timePoint.calendar();
        }
        else {
            return timePoint.fromNow();
        }
    };
    RelativeTimePipe.decorators = [
        { type: Pipe, args: [{
                    name: 'relativeTime'
                },] }
    ];
    return RelativeTimePipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var hourInMillis = 3600 * 1000;
var FormatDurationPipe = /** @class */ (function () {
    function FormatDurationPipe() {
    }
    /**
     * @param {?} milliSeconds
     * @return {?}
     */
    FormatDurationPipe.prototype.transform = /**
     * @param {?} milliSeconds
     * @return {?}
     */
    function (milliSeconds) {
        if (milliSeconds < hourInMillis) {
            return utc(duration(milliSeconds).asMilliseconds()).format('mm:ss');
        }
        return utc(duration(milliSeconds).asMilliseconds()).format('h:mm:ss');
    };
    FormatDurationPipe.decorators = [
        { type: Pipe, args: [{
                    name: 'formatDuration'
                },] }
    ];
    return FormatDurationPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var LocalStorageService = /** @class */ (function () {
    function LocalStorageService() {
    }
    /**
     * @param {?} key
     * @return {?}
     */
    LocalStorageService.prototype.getItem = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        return localStorage.getItem(key);
    };
    /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    LocalStorageService.prototype.setItem = /**
     * @param {?} key
     * @param {?} value
     * @return {?}
     */
    function (key, value) {
        localStorage.setItem(key, value);
    };
    /**
     * @param {?} key
     * @return {?}
     */
    LocalStorageService.prototype.removeItem = /**
     * @param {?} key
     * @return {?}
     */
    function (key) {
        localStorage.removeItem(key);
    };
    LocalStorageService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    LocalStorageService.ctorParameters = function () { return []; };
    /** @nocollapse */ LocalStorageService.ngInjectableDef = defineInjectable({ factory: function LocalStorageService_Factory() { return new LocalStorageService(); }, token: LocalStorageService, providedIn: "root" });
    return LocalStorageService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment$2 = moment;
var CacheInterceptorService = /** @class */ (function () {
    function CacheInterceptorService(router) {
        this.router = router;
        this.TTL = 2 * 60;
    }
    // Only allow caching of get requests
    /**
     * @param {?} req
     * @return {?}
     */
    CacheInterceptorService.prototype.isCachable = /**
     * @param {?} req
     * @return {?}
     */
    function (req) {
        return (
        // only for timeline
        this.router.url.includes('/connect/')
            &&
                req.method === 'GET'
            &&
                // Do not cache files
                !req.urlWithParams.includes('/files/'));
    };
    // tslint:disable-next-line:typedef  // FIXME
    /**
     * @param {?} match
     * @return {?}
     */
    CacheInterceptorService.prototype.purge = /**
     * @param {?} match
     * @return {?}
     */
    function (match) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.keys(CacheInterceptorService.cache)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (key.includes(match)) {
                    delete CacheInterceptorService.cache[key];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * @param {?} req
     * @return {?}
     */
    CacheInterceptorService.prototype.computeUniqueId = /**
     * @param {?} req
     * @return {?}
     */
    function (req) {
        return req.method + "--" + req.urlWithParams + "--" + req.serializeBody();
    };
    /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    CacheInterceptorService.prototype.intercept = /**
     * @param {?} req
     * @param {?} next
     * @return {?}
     */
    function (req, next) {
        var _this = this;
        ++CacheInterceptorService.count;
        if (!this.isCachable(req)) {
            return next.handle(req);
        }
        ++CacheInterceptorService.countCacheable;
        /** @type {?} */
        var id = this.computeUniqueId(req);
        /** @type {?} */
        var cachedItem = CacheInterceptorService.cache[id];
        // Use cache if valid
        if (cachedItem && cachedItem.expiration > new Date()) {
            ++CacheInterceptorService.countCached;
            ++cachedItem.timesUsed;
            // To turn off caching, comment following line
            return Observable.of(cachedItem.response);
        }
        /** @type {?} */
        var requestingItem = CacheInterceptorService.requestingCache[id];
        if (requestingItem && requestingItem.expiration > new Date()) {
            /** @type {?} */
            var promise = new Promise(function (resolve) {
                requestingItem.promises.push(resolve);
            });
            // To turn off de-duplication, comment following line
            return from(promise);
        }
        CacheInterceptorService.requestingCache[id] = {
            expiration: moment$2().add(this.TTL, 'seconds').toDate(),
            promises: [],
        };
        return next.handle(req).do(function (event) {
            // Intercept and save successful requests
            if (event instanceof HttpResponse) {
                CacheInterceptorService.cache[id] = {
                    expiration: moment$2().add(_this.TTL, 'seconds').toDate(),
                    response: event,
                    timesUsed: 0,
                };
                CacheInterceptorService.requestingCache[id].promises.forEach(function (resolve) { return resolve(event); });
                delete CacheInterceptorService.requestingCache[id];
            }
        });
    };
    CacheInterceptorService.cache = {};
    CacheInterceptorService.requestingCache = {};
    CacheInterceptorService.count = 0;
    CacheInterceptorService.countCacheable = 0;
    CacheInterceptorService.countCached = 0;
    CacheInterceptorService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    CacheInterceptorService.ctorParameters = function () { return [
        { type: Router }
    ]; };
    /** @nocollapse */ CacheInterceptorService.ngInjectableDef = defineInjectable({ factory: function CacheInterceptorService_Factory() { return new CacheInterceptorService(inject(Router)); }, token: CacheInterceptorService, providedIn: "root" });
    return CacheInterceptorService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var LOCALSTORAGE_THEME = 'LOCALSTORAGE_THEME';
/** @enum {string} */
var Theme = {
    Light: 'theme-light',
    Dark: 'theme-dark',
};
var ThemeService = /** @class */ (function () {
    function ThemeService(storage) {
        this.storage = storage;
        /** @type {?} */
        var storedTheme = this.storage.getItem(LOCALSTORAGE_THEME);
        if (storedTheme && storedTheme.length > 0) {
            this.theme = /** @type {?} */ (storedTheme);
        }
        else {
            this.theme = Theme.Dark;
        }
        this.useTheme(this.theme);
    }
    /**
     * @param {?} theme
     * @return {?}
     */
    ThemeService.prototype.useTheme = /**
     * @param {?} theme
     * @return {?}
     */
    function (theme) {
        this.theme = theme;
        document.documentElement.className = this.theme;
        this.storage.setItem(LOCALSTORAGE_THEME, this.theme);
    };
    /**
     * @return {?}
     */
    ThemeService.prototype.toggleTheme = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var allThemes = Object.keys(Theme);
        /** @type {?} */
        var curIdx = allThemes.map(function (t) { return Theme[t]; }).indexOf(this.theme);
        if (curIdx + 1 === allThemes.length) {
            this.useTheme(Theme[allThemes[0]]);
        }
        else {
            this.useTheme(Theme[allThemes[curIdx + 1]]);
        }
    };
    ThemeService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    ThemeService.ctorParameters = function () { return [
        { type: LocalStorageService }
    ]; };
    /** @nocollapse */ ThemeService.ngInjectableDef = defineInjectable({ factory: function ThemeService_Factory() { return new ThemeService(inject(LocalStorageService)); }, token: ThemeService, providedIn: "root" });
    return ThemeService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var Environment = /** @class */ (function () {
    function Environment() {
    }
    return Environment;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var S2AHttpClient = /** @class */ (function () {
    function S2AHttpClient(http, environment) {
        if (environment === void 0) { environment = /** @type {?} */ ({}); }
        this.http = http;
        this.environment = environment;
    }
    /**
     * POST request
     * @template T
     * @param {?} endPoint end point of the api
     * @param {?} params body of the request.
     * @param {?=} options options of the request like headers, body, etc.
     * @return {?}
     */
    S2AHttpClient.prototype.post = /**
     * POST request
     * @template T
     * @param {?} endPoint end point of the api
     * @param {?} params body of the request.
     * @param {?=} options options of the request like headers, body, etc.
     * @return {?}
     */
    function (endPoint, params, options) {
        return this.http.post(this.environment.baseUrl + endPoint, params, options);
    };
    /**
     * PATCH request
     * @template T
     * @param {?} endPoint end point of the api
     * @param {?} params body of the request.
     * @param {?=} options options of the request like headers, body, etc.
     * @return {?}
     */
    S2AHttpClient.prototype.patch = /**
     * PATCH request
     * @template T
     * @param {?} endPoint end point of the api
     * @param {?} params body of the request.
     * @param {?=} options options of the request like headers, body, etc.
     * @return {?}
     */
    function (endPoint, params, options) {
        return this.http.patch(this.environment.baseUrl + endPoint, params, options);
    };
    /**
     * GET request
     * @template T
     * @param {?} endPoint it doesn't need / in front of the end point
     * @param {?=} options options of the request like headers, body, etc.
     * @return {?}
     */
    S2AHttpClient.prototype.get = /**
     * GET request
     * @template T
     * @param {?} endPoint it doesn't need / in front of the end point
     * @param {?=} options options of the request like headers, body, etc.
     * @return {?}
     */
    function (endPoint, options) {
        return this.http.get(this.environment.baseUrl + endPoint, options);
    };
    /**
     * PUT request
     * @template T
     * @param {?} endPoint end point of the api
     * @param {?} params body of the request.
     * @param {?=} options options of the request like headers, body, etc.
     * @return {?}
     */
    S2AHttpClient.prototype.put = /**
     * PUT request
     * @template T
     * @param {?} endPoint end point of the api
     * @param {?} params body of the request.
     * @param {?=} options options of the request like headers, body, etc.
     * @return {?}
     */
    function (endPoint, params, options) {
        return this.http.put(this.environment.baseUrl + endPoint, params, options);
    };
    /**
     * DELETE request
     * @template T
     * @param {?} endPoint end point of the api
     * @param {?=} options options of the request like headers, body, etc.
     * @return {?}
     */
    S2AHttpClient.prototype.delete = /**
     * DELETE request
     * @template T
     * @param {?} endPoint end point of the api
     * @param {?=} options options of the request like headers, body, etc.
     * @return {?}
     */
    function (endPoint, options) {
        return this.http.delete(this.environment.baseUrl + endPoint, options);
    };
    S2AHttpClient.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    S2AHttpClient.ctorParameters = function () { return [
        { type: HttpClient },
        { type: Environment }
    ]; };
    /** @nocollapse */ S2AHttpClient.ngInjectableDef = defineInjectable({ factory: function S2AHttpClient_Factory() { return new S2AHttpClient(inject(HttpClient), inject(Environment)); }, token: S2AHttpClient, providedIn: "root" });
    return S2AHttpClient;
}());
/**
 * @param {?} http
 * @param {?} env
 * @return {?}
 */
function S2AHttpClientCreator(http, env) {
    return new S2AHttpClient(http, env);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var LunchlistService = /** @class */ (function () {
    function LunchlistService(http) {
        this.http = http;
    }
    /**
     * @return {?}
     */
    LunchlistService.prototype.getSession = /**
     * @return {?}
     */
    function () {
        return __awaiter(this, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.post('lunchlist/session', {}).toPromise()];
                    case 1:
                        result = _a.sent();
                        return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    LunchlistService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    LunchlistService.ctorParameters = function () { return [
        { type: S2AHttpClient }
    ]; };
    /** @nocollapse */ LunchlistService.ngInjectableDef = defineInjectable({ factory: function LunchlistService_Factory() { return new LunchlistService(inject(S2AHttpClient)); }, token: LunchlistService, providedIn: "root" });
    return LunchlistService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var LOCALSTORAGE_LANGUAGE = 'LOCALSTORAGE_LANGUAGE';
var TranslateHelperService = /** @class */ (function () {
    function TranslateHelperService(translate, storage) {
        var _this = this;
        this.translate = translate;
        this.storage = storage;
        this.availableLanguages = [];
        this.setup = function () {
            _this.setDefaultLang(_this.getDefaultLanguage());
            /** @type {?} */
            var startLanguage = _this.loadStoredLanguage();
            _this.translate.use(startLanguage.key);
        };
        this.getDefaultLanguage = function () {
            return _this.availableLanguages[0];
        };
        this.getCurrentLanguage = function () {
            return _this.loadStoredLanguage();
        };
        this.switchLanguage = function (lang) {
            _this.saveStoredLanguage(lang);
            _this.use(lang);
        };
        this.findLanguageByKey = function (key) {
            /** @type {?} */
            var filterLang = _this.availableLanguages.filter(function (l) { return l.key = key; });
            if (filterLang.length === 0) {
                return undefined;
            }
            else {
                return filterLang[0];
            }
        };
        this.use = function (lang) {
            _this.translate.use(lang.key);
        };
        this.setDefaultLang = function (lang) {
            _this.translate.setDefaultLang(lang.key);
        };
        this.loadStoredLanguage = function () {
            /** @type {?} */
            var loadedKey = _this.storage.getItem(LOCALSTORAGE_LANGUAGE);
            if (!loadedKey) {
                /** @type {?} */
                var lang = _this.getDefaultLanguage();
                _this.saveStoredLanguage(lang);
                return lang;
            }
            else {
                return _this.availableLanguages.filter(function (l) { return l.key === loadedKey; })[0];
            }
        };
        this.saveStoredLanguage = function (lang) {
            _this.storage.setItem(LOCALSTORAGE_LANGUAGE, lang.key);
        };
        this.availableLanguages.push({
            key: 'en',
            description: 'English'
        });
        this.availableLanguages.push({
            key: 'de',
            description: 'Deutsch'
        });
    }
    TranslateHelperService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    TranslateHelperService.ctorParameters = function () { return [
        { type: TranslateService },
        { type: LocalStorageService }
    ]; };
    /** @nocollapse */ TranslateHelperService.ngInjectableDef = defineInjectable({ factory: function TranslateHelperService_Factory() { return new TranslateHelperService(inject(TranslateService), inject(LocalStorageService)); }, token: TranslateHelperService, providedIn: "root" });
    return TranslateHelperService;
}());
/**
 * @param {?} http
 * @return {?}
 */
function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http, 'assets/i18n/');
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BasePageComponent = /** @class */ (function () {
    function BasePageComponent() {
        this.isLoading = false;
        this.scrollToBottom = function (timeout) {
            /** @type {?} */
            var to = (timeout) ? timeout : 0;
            setTimeout(function () {
                window.scrollTo(0, document.body.scrollHeight);
            }, to);
        };
        this.inputHasError = function (input) {
            return input.invalid && (input.dirty || input.touched);
        };
    }
    /**
     * @return {?}
     */
    BasePageComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    BasePageComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-base-page',
                    template: "<p>\n  BASE PAGE DUMMY CONTAINER\n</p>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    BasePageComponent.ctorParameters = function () { return []; };
    return BasePageComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var AppInjector;
/**
 * @param {?} injector
 * @return {?}
 */
function setAppInjector(injector) {
    if (AppInjector) {
        // Should not happen
        console.error('Programming error: AppInjector was already set');
    }
    else {
        AppInjector = injector;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BaseModalPageComponent = /** @class */ (function () {
    function BaseModalPageComponent(modalRef) {
        this.modalRef = modalRef;
        this.isLoading = false;
        this.inputHasError = function (input) {
            return input.invalid && (input.dirty || input.touched);
        };
        // Check if a Instance of the injector exists
        if (AppInjector) {
            this.translate = AppInjector.get(TranslateService);
        }
    }
    /**
     * @return {?}
     */
    BaseModalPageComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    BaseModalPageComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-base-modal-page',
                    template: "<p>\n  base-modal-page works!\n</p>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    BaseModalPageComponent.ctorParameters = function () { return [
        { type: BsModalRef }
    ]; };
    return BaseModalPageComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BaseModalErrorComponent = /** @class */ (function (_super) {
    __extends(BaseModalErrorComponent, _super);
    function BaseModalErrorComponent(modalRef) {
        var _this = _super.call(this, modalRef) || this;
        _this.modalRef = modalRef;
        if (AppInjector) {
            _this.modalService = AppInjector.get(BsModalService);
        }
        return _this;
    }
    /**
     * @param {?} parentClass
     * @param {?} parentModalRef
     * @param {?} errorTitle
     * @param {?} errorText
     * @return {?}
     */
    BaseModalErrorComponent.openError = /**
     * @param {?} parentClass
     * @param {?} parentModalRef
     * @param {?} errorTitle
     * @param {?} errorText
     * @return {?}
     */
    function (parentClass, parentModalRef, errorTitle, errorText) {
        /** @type {?} */
        var config = {
            class: 'modal-xs modal-error',
            initialState: {
                title: errorTitle,
                error: errorText,
                parentModalType: parentClass,
                parentModalConfig: AppInjector.get(BsModalService).config,
                parentModalRef: parentModalRef
            },
            ignoreBackdropClick: true
        };
        return AppInjector.get(BsModalService).show(BaseModalErrorComponent, config);
    };
    /**
     * @return {?}
     */
    BaseModalErrorComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    BaseModalErrorComponent.prototype.close = /**
     * @return {?}
     */
    function () {
        // Add the desired data
        if (this.parentModalConfig.initialState['equipment'] === undefined
            && this.parentModalRef.content['equipment'] !== undefined) {
            this.parentModalConfig.initialState['equipment'] = this.parentModalRef.content['equipment'];
        }
        // Hide this modal and display the previous one
        this.modalRef.hide();
        this.modalRef = this.modalService.show(this.parentModalType, this.parentModalConfig);
    };
    BaseModalErrorComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-base-modal-error',
                    template: "<s2a-modal-header [title]=\"title\" [modalRef]=\"modalRef\"></s2a-modal-header>\n\n<div class=\"modal-body\">\n  <span>{{this.error}}</span>\n  <hr class=\"transparent small\">\n  <div class=\"text-right\">\n    <button class=\"btn btn-primary btn-leaf\" (click)=\"close();\" translate>global.close</button>\n  </div>\n  <hr class=\"transparent small\">\n</div>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    BaseModalErrorComponent.ctorParameters = function () { return [
        { type: BsModalRef }
    ]; };
    return BaseModalErrorComponent;
}(BaseModalPageComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var BaseSubscriptionsPageComponent = /** @class */ (function (_super) {
    __extends(BaseSubscriptionsPageComponent, _super);
    function BaseSubscriptionsPageComponent() {
        var _this = _super.call(this) || this;
        _this.subscriptions = [];
        return _this;
    }
    /**
     * @return {?}
     */
    BaseSubscriptionsPageComponent.prototype.ngOnDestroy = /**
     * @return {?}
     */
    function () {
        this.subscriptions.forEach(function (subscription) {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    };
    /**
     * @param {?} subscription
     * @return {?}
     */
    BaseSubscriptionsPageComponent.prototype.addSubscription = /**
     * @param {?} subscription
     * @return {?}
     */
    function (subscription) {
        this.subscriptions.push(subscription);
    };
    BaseSubscriptionsPageComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-base-subscriptions-page',
                    template: "<p>\n  You need to implement the Base Subscription Page!\n</p>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    BaseSubscriptionsPageComponent.ctorParameters = function () { return []; };
    return BaseSubscriptionsPageComponent;
}(BasePageComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ModalHeaderComponent = /** @class */ (function () {
    function ModalHeaderComponent() {
    }
    /**
     * @return {?}
     */
    ModalHeaderComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ModalHeaderComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-modal-header',
                    template: "<div class=\"modal-header\">\n  <h4>{{title}}</h4>\n  <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"modalRef.hide()\">\n    <svg-icon class=\"notification-icon\" src=\"assets/icons/cancel.svg\"></svg-icon>\n  </button>\n</div>\n",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ModalHeaderComponent.ctorParameters = function () { return []; };
    ModalHeaderComponent.propDecorators = {
        title: [{ type: Input }],
        modalRef: [{ type: Input }]
    };
    return ModalHeaderComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var moment$3 = moment;
/**
 *  Service for basic formatting of moment duration.
 *  String format: PnYnMnDTnHnMnS
 *
 *  PTnHnMnS -> formatted to: 05:04:32 h:m:s
 *  P1Y3M2DT1H3M5.6S -> formatted to: 01:03:02:01:03:05 y:m:d:h:m:s
 */
var MomentJsDurationService = /** @class */ (function () {
    function MomentJsDurationService(translate) {
        this.translate = translate;
    }
    /**
     * @param {?} unixTimestamp
     * @param {?} format
     * @return {?}
     */
    MomentJsDurationService.prototype.formatUnixTimestamp = /**
     * @param {?} unixTimestamp
     * @param {?} format
     * @return {?}
     */
    function (unixTimestamp, format) {
        /** @type {?} */
        var momentDatetime = moment$3(unixTimestamp);
        return momentDatetime.format(format);
    };
    // PnYnMnDTnHnMnS -> nHnMnS
    /**
     * @param {?} isoString
     * @return {?}
     */
    MomentJsDurationService.prototype.extractTimePart = /**
     * @param {?} isoString
     * @return {?}
     */
    function (isoString) {
        /** @type {?} */
        var timePart = isoString.indexOf('T');
        if (!timePart) {
            return null;
        }
        return isoString.substring(isoString.indexOf('T'));
    };
    // PnYnMnDTnHnMnS -> nYnMnD
    /**
     * @param {?} isoString
     * @return {?}
     */
    MomentJsDurationService.prototype.extractDatePart = /**
     * @param {?} isoString
     * @return {?}
     */
    function (isoString) {
        /** @type {?} */
        var endTimePart = isoString.indexOf('T');
        if (isoString.indexOf('T') >= 1) {
            return isoString.substring(0, isoString.indexOf('T'));
        }
        else {
            return '';
        }
    };
    /**
     * @param {?} isoString
     * @return {?}
     */
    MomentJsDurationService.prototype.formatDatePart = /**
     * @param {?} isoString
     * @return {?}
     */
    function (isoString) {
        /** @type {?} */
        var timePart = this.extractDatePart(isoString);
        /** @type {?} */
        var years = this.extractPart(timePart, 'Y');
        /** @type {?} */
        var months = this.extractPart(timePart, 'M');
        /** @type {?} */
        var days = this.extractPart(timePart, 'D');
        years = this.addZero(years);
        months = this.addZero(months);
        days = this.addZero(days);
        years = this.cutAfterdot(years);
        months = this.cutAfterdot(months);
        days = this.cutAfterdot(days);
        years = years ? years + ':' : '00:';
        months = months ? months + ':' : '00:';
        days = days ? days + ':' : '00:';
        if (years === '00:') {
            if (months === '00:') {
                return days === '00:' ? '' : days;
            }
            else {
                return months + days;
            }
        }
        else {
            return years + months + days;
        }
    };
    /**
     * @param {?} isoString
     * @param {?} canStartWithZeros
     * @return {?}
     */
    MomentJsDurationService.prototype.formatTimePart = /**
     * @param {?} isoString
     * @param {?} canStartWithZeros
     * @return {?}
     */
    function (isoString, canStartWithZeros) {
        /** @type {?} */
        var timePart = this.extractTimePart(isoString);
        /** @type {?} */
        var hours = this.extractPart(timePart, 'H');
        /** @type {?} */
        var minutes = this.extractPart(timePart, 'M');
        /** @type {?} */
        var seconds = this.extractPart(timePart, 'S');
        hours = this.addZero(hours);
        minutes = this.addZero(minutes);
        seconds = this.addZero(seconds);
        hours = this.cutAfterdot(hours);
        minutes = this.cutAfterdot(minutes);
        seconds = this.cutAfterdot(seconds);
        hours = hours ? hours + ':' : '00:';
        minutes = minutes ? minutes + ':' : '00:';
        seconds = seconds ? seconds : '00';
        if (!canStartWithZeros) {
            if (hours === '00:') {
                if (minutes === '00:') {
                    return seconds === '00:' ? '' : seconds;
                }
                else {
                    return minutes + seconds;
                }
            }
            else {
                return hours + minutes + seconds;
            }
        }
        else {
            return hours + minutes + seconds;
        }
    };
    /**
     * @param {?} part
     * @return {?}
     */
    MomentJsDurationService.prototype.addZero = /**
     * @param {?} part
     * @return {?}
     */
    function (part) {
        return (parseInt(part, 10) < 10) ? '0' + part : part;
    };
    /**
     * @param {?} numberString
     * @return {?}
     */
    MomentJsDurationService.prototype.cutAfterdot = /**
     * @param {?} numberString
     * @return {?}
     */
    function (numberString) {
        if (numberString.indexOf('.') >= 0) {
            return numberString.substring(0, numberString.indexOf('.'));
        }
        else {
            return numberString;
        }
    };
    /**
     * @param {?} isoString
     * @param {?} part
     * @return {?}
     */
    MomentJsDurationService.prototype.extractPart = /**
     * @param {?} isoString
     * @param {?} part
     * @return {?}
     */
    function (isoString, part) {
        /** @type {?} */
        var partExist = isoString.indexOf(part);
        if (partExist < 0) {
            return '';
        }
        else {
            /** @type {?} */
            var extractedPart = isoString.substring(0, isoString.indexOf(part));
            /** @type {?} */
            var letter = void 0;
            for (var i = extractedPart.length - 1; i--;) {
                letter = extractedPart[i];
                if (!(letter === '.') && isNaN(letter)) {
                    return extractedPart.substring(i + 1);
                }
            }
        }
    };
    /**
     * @param {?} isoString
     * @return {?}
     */
    MomentJsDurationService.prototype.formatDuration = /**
     * @param {?} isoString
     * @return {?}
     */
    function (isoString) {
        return this.formatDatePart(isoString) + this.formatTimePart(isoString, false);
    };
    /**
     * format the duration:
     * if it is less than a day -> hh:mm:ss -> 22:06:12
     * if it is more than a day -> >days d -> en: >2 d, de: >2t
     * @param duration
     */
    /**
     * format the duration:
     * if it is less than a day -> hh:mm:ss -> 22:06:12
     * if it is more than a day -> >days d -> en: >2 d, de: >2t
     * @param {?} duration
     * @return {?}
     */
    MomentJsDurationService.prototype.formatDurationDaysOrTime = /**
     * format the duration:
     * if it is less than a day -> hh:mm:ss -> 22:06:12
     * if it is more than a day -> >days d -> en: >2 d, de: >2t
     * @param {?} duration
     * @return {?}
     */
    function (duration$$1) {
        /** @type {?} */
        var daysInMillis = 3600 * 1000 * 24;
        /** @type {?} */
        var milliSeconds = duration$$1.asMilliseconds();
        if (milliSeconds < daysInMillis) {
            return this.formatTimePart(duration$$1.toISOString(), true);
        }
        else {
            return '>' + Math.round(milliSeconds / daysInMillis) + ' ' + this.translate.instant('global.day_shortcut');
        }
    };
    MomentJsDurationService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    MomentJsDurationService.ctorParameters = function () { return [
        { type: TranslateService }
    ]; };
    /** @nocollapse */ MomentJsDurationService.ngInjectableDef = defineInjectable({ factory: function MomentJsDurationService_Factory() { return new MomentJsDurationService(inject(TranslateService)); }, token: MomentJsDurationService, providedIn: "root" });
    return MomentJsDurationService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var SpinnerComponent = /** @class */ (function () {
    function SpinnerComponent() {
        this.inline = false;
    }
    /**
     * @return {?}
     */
    SpinnerComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    SpinnerComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-spinner',
                    template: "<div class=\"spinner\" [class.inline]=\"inline\">\n  <div class=\"bounce1\"></div>\n  <div class=\"bounce2\"></div>\n  <div class=\"bounce3\"></div>\n</div>",
                    styles: [":host .spinner{margin:5px;width:100%;text-align:center}:host .inline{display:inline}:host .spinner>div{width:18px;height:18px;border-radius:100%;display:inline-block;-webkit-animation:1.4s ease-in-out infinite both sk-bouncedelay;animation:1.4s ease-in-out infinite both sk-bouncedelay}.theme-light :host .spinner>div{background:linear-gradient(-135deg,#50bee4 0,#2874ba 100%)}.theme-dark :host .spinner>div{background:linear-gradient(-135deg,#50bee4 0,#2874ba 100%)}@media print{.theme-dark :host .spinner>div{background:linear-gradient(-135deg,#50bee4 0,#2874ba 100%)}}:host .spinner .bounce1{-webkit-animation-delay:-.32s;animation-delay:-.32s}:host .spinner .bounce2{-webkit-animation-delay:-.16s;animation-delay:-.16s}@-webkit-keyframes sk-bouncedelay{0%,100%,80%{-webkit-transform:scale(0)}40%{-webkit-transform:scale(1)}}@keyframes sk-bouncedelay{0%,100%,80%{-webkit-transform:scale(0);transform:scale(0)}40%{-webkit-transform:scale(1);transform:scale(1)}}"]
                }] }
    ];
    /** @nocollapse */
    SpinnerComponent.ctorParameters = function () { return []; };
    SpinnerComponent.propDecorators = {
        inline: [{ type: Input }]
    };
    return SpinnerComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var LanguageSelectionComponent = /** @class */ (function (_super) {
    __extends(LanguageSelectionComponent, _super);
    function LanguageSelectionComponent(modalRef, translateHelper) {
        var _this = _super.call(this, modalRef) || this;
        _this.modalRef = modalRef;
        _this.translateHelper = translateHelper;
        _this.switchLanguage = function (lang) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.translateHelper.switchLanguage(lang);
                this.modalRef.hide();
                return [2 /*return*/];
            });
        }); };
        return _this;
    }
    /**
     * @return {?}
     */
    LanguageSelectionComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    LanguageSelectionComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-language-selection',
                    template: "<s2a-modal-header title=\"{{ 'components.language_selection.title' | translate }}\" [modalRef]=\"modalRef\"></s2a-modal-header>\n<div class=\"modal-body\">\n  <div class=\"table-responsive\">\n    <table class=\"table language-table\">\n      <tr *ngFor=\"let lang of translateHelper.availableLanguages\" (click)=\"switchLanguage(lang)\"\n      [ngClass]=\"{'selected': (lang === translateHelper.getCurrentLanguage())}\">\n        <td><a class=\"btn btn-link\">{{lang.description}}</a></td>\n      </tr>\n    </table>\n  </div>\n</div>\n<!--\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary btn-leaf float-right\" type=\"Submit\" (click)=\"modalRef.hide()\" translate>global.close</button>\n</div>\n-->\n",
                    styles: [":host .modal-body{padding:0;margin:0}:host .modal-content{padding:0;margin:0}:host .language-table{padding:0;margin:0}:host .language-table tr{transition:.3s linear;background-color:transparent}.theme-light :host .language-table tr{border-color:#e0e0e0;color:#525252}.theme-dark :host .language-table tr{border-color:#405b7c;color:#fff}:host .language-table tr:hover{cursor:pointer}.theme-light :host .language-table tr:hover{background-color:#f7f7f7;color:#525252}.theme-dark :host .language-table tr:hover{background-color:#193a61;color:#fff}@media print{.theme-dark :host .language-table tr{border-color:#e0e0e0;color:#525252}.theme-dark :host .language-table tr:hover{background-color:#f7f7f7;color:#525252}}.theme-light :host .language-table tr.selected{background-color:#f7f7f7;color:#525252}.theme-dark :host .language-table tr.selected{background-color:#193a61;color:#fff}@media print{.theme-dark :host .language-table tr.selected{background-color:#f7f7f7;color:#525252}}"]
                }] }
    ];
    /** @nocollapse */
    LanguageSelectionComponent.ctorParameters = function () { return [
        { type: BsModalRef },
        { type: TranslateHelperService }
    ]; };
    return LanguageSelectionComponent;
}(BaseModalPageComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var InputValidationComponent = /** @class */ (function () {
    function InputValidationComponent() {
    }
    /**
     * @return {?}
     */
    InputValidationComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    InputValidationComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-input-validation',
                    template: "<div *ngIf=\"formInput && formInput.invalid && ((formInput.dirty || formInput.touched) || validateInput)\" class=\"alert alert-danger\">\n  \n    <div *ngIf=\"formInput.errors.required\">\n      <span *ngIf=\"messagePrefix\">{{messagePrefix | translate}}: </span>\n      {{'components.global.input_validation.required' | translate}}\n    </div>\n\n    <div *ngIf=\"formInput.errors.min\">\n      <span *ngIf=\"messagePrefix\">{{messagePrefix | translate}}: </span>\n      <span translate [translateParams]=\"{min: formInput.errors.min.min | json, actual: formInput.errors.min.actual | json}\">\n        components.global.input_validation.min\n      </span>\n    </div>\n\n    <div *ngIf=\"formInput.errors.max\">\n      <span *ngIf=\"messagePrefix\">{{messagePrefix | translate}}: </span>\n      <span translate [translateParams]=\"{max: formInput.errors.max.max | json, actual: formInput.errors.max.actual | json}\">\n        components.global.input_validation.max\n      </span>\n    </div>\n\n    <div *ngIf=\"formInput.errors.minlength\">\n      <span *ngIf=\"messagePrefix\">{{messagePrefix | translate}}: </span>\n      <span translate [translateParams]=\"{minlength: formInput.errors.minlength.requiredLength | json, actual: formInput.errors.minlength.actualLength | json}\">\n        components.global.input_validation.minlength\n      </span>\n      </div>\n  \n    <div *ngIf=\"formInput.errors.maxlength\">\n      <span *ngIf=\"messagePrefix\">{{messagePrefix | translate}}: </span>\n      <span translate [translateParams]=\"{maxlength: formInput.errors.maxlength.requiredLength | json, actual: formInput.errors.maxlength.actualLength | json}\">\n        components.global.input_validation.maxlength\n      </span>\n    </div>\n\n  </div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    InputValidationComponent.ctorParameters = function () { return []; };
    InputValidationComponent.propDecorators = {
        formInput: [{ type: Input }],
        messagePrefix: [{ type: Input }],
        validateInput: [{ type: Input }]
    };
    return InputValidationComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var IconHelperService = /** @class */ (function () {
    function IconHelperService(env) {
        this.env = env;
    }
    /**
     * @param {?} path
     * @param {?} name
     * @return {?}
     */
    IconHelperService.prototype.getIconUrl = /**
     * @param {?} path
     * @param {?} name
     * @return {?}
     */
    function (path, name) {
        return this.env.iconUrl + path + name + '.svg';
    };
    IconHelperService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    IconHelperService.ctorParameters = function () { return [
        { type: Environment }
    ]; };
    /** @nocollapse */ IconHelperService.ngInjectableDef = defineInjectable({ factory: function IconHelperService_Factory() { return new IconHelperService(inject(Environment)); }, token: IconHelperService, providedIn: "root" });
    return IconHelperService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * Component for loading icons from icon service.
 *
 * The title attribute will be displayed as a tooltip
 * Usage:
 * <s2a-svg-icon title="This icon means ..." path="global/actions/" name="add" class="someClass"></s2a-svg-icon>
 */
var SvgIconComponent = /** @class */ (function () {
    function SvgIconComponent(iconHelperService) {
        this.iconHelperService = iconHelperService;
        this.title = '';
    }
    /**
     * @return {?}
     */
    SvgIconComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    SvgIconComponent.prototype.getIconUrl = /**
     * @return {?}
     */
    function () {
        return this.iconHelperService.getIconUrl(this.path, this.name);
    };
    SvgIconComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-svg-icon',
                    template: "<span kendoTooltip>\n  <svg-icon title=\"{{ title }}\" src=\"{{getIconUrl()}}\" class=\"{{class}}\"></svg-icon>\n</span>",
                    styles: [":host .addButton{width:64px;height:64px}:host .dropdownButton{width:24px;height:24px;top:8px;position:absolute;-webkit-transform:rotate(180deg);transform:rotate(180deg)}:host .deleteButton{position:absolute;top:0;width:44px;height:44px}:host .eventLevelIcon{width:32px;height:32px}:host .navigationButton{display:inline-block;width:32px;height:32px;-webkit-transform:rotate(180deg);transform:rotate(180deg);transition:.1s linear}:host .toggleButton{display:inline-block;width:32px;height:32px;position:absolute;top:9px;right:5px;-webkit-transform:rotate(90deg);transform:rotate(90deg);transition:.1s linear}:host .confirmationButton{top:0;width:38px;height:38px}:host .trashButton{top:4px;left:-8px;position:absolute;width:30px;height:30px}.theme-light :host .trashButton{color:#fff!important}.theme-dark :host .trashButton{color:#fff!important}@media print{.theme-dark :host .trashButton{color:#fff!important}}"]
                }] }
    ];
    /** @nocollapse */
    SvgIconComponent.ctorParameters = function () { return [
        { type: IconHelperService }
    ]; };
    SvgIconComponent.propDecorators = {
        path: [{ type: Input }],
        name: [{ type: Input }],
        class: [{ type: Input }],
        title: [{ type: Input }]
    };
    return SvgIconComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 *
 * Short guide on using this simple debugger
 * ===
 *
 * This simple logger uses the popular debug package from npm (https://www.npmjs.com/package/debug) with
 * support for namespaces, filtering and colored output.
 *
 * Usage in browser
 * ---
 *
 * Simply set the following variable in the browser's local storage:
 *
 * > localStorage.debug = 's2a:*'
 *
 * You can exclude/include your namespace by varying the logger expression. E.g. `s2a:*` shows all
 * logger output which have a namespace starting with this expression. You can restrict output to your
 * own module with e.g. `s2a:my-module` etc.
 *
 * Note: if you use `localStorage.debug = '*'` you get all logging output, also from other modules
 * like sockjs etc. since many modules use the debug package.
 *
 * Note: see also https://www.npmjs.com/package/debug#wildcards for further infor on filtering output.
 *
 * Usage in code
 * ---
 *
 * At the head of the file, get the logger and set the namespace:
 *
 * > import { Logger } from '\@s2a/ng-common';
 * > const logger = Logger('my-module');
 *
 * Then you can use logger.{trace|debug|info|warn|error|fatal}(...) inside the file at any place and
 * get pretty output in the console. See https://github.com/trentm/node-bunyan#levels for a documentation
 * about when to use which log level.
 *
 * Further advantage: in a production system this module
 * @param {?} namespace
 * @return {?}
 */
function Logger(namespace) {
    /** @type {?} */
    var debugWrapper = function (debugNamespace, level) {
        // tslint:disable-next-line:typedef  // FIXME
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            /** @type {?} */
            var newArguments = [level];
            for (var i = 0; i < arguments.length; i++) {
                newArguments.push(arguments[i]);
            }
            debug(debugNamespace).apply(this, newArguments);
        };
    };
    /**
       * For usage of levels, see this documentation: https://github.com/trentm/node-bunyan#levels
       */
    return {
        trace: debugWrapper('s2a:' + namespace, 'TRACE'),
        // Very detailed logging
        debug: debugWrapper('s2a:' + namespace, 'DEBUG'),
        // Anything else too verbose for info
        info: debugWrapper('s2a:' + namespace, 'INFO'),
        // Detail on reglular operation
        warn: debugWrapper('s2a:' + namespace, 'WARN'),
        // Should probably looked at
        error: debugWrapper('s2a:' + namespace, 'ERROR'),
        // Fatal for a particular request/operation, app works
        fatal: debugWrapper('s2a:' + namespace, 'FATAL') // App gets unusable now
    };
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var logger = Logger('global');
var ConfirmationDialogComponent = /** @class */ (function () {
    function ConfirmationDialogComponent(modalRef) {
        this.modalRef = modalRef;
    }
    /**
     * @return {?}
     */
    ConfirmationDialogComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    ConfirmationDialogComponent.prototype.confirm = /**
     * @return {?}
     */
    function () {
        this.action = 'confirm';
        logger.debug('confirmed');
        this.modalRef.hide();
    };
    /**
     * @return {?}
     */
    ConfirmationDialogComponent.prototype.decline = /**
     * @return {?}
     */
    function () {
        this.action = 'abort';
        logger.debug('declined');
        this.modalRef.hide();
    };
    /**
     * @param {?} baseComponent
     * @param {?} data
     * @param {?} reason
     * @param {?} confirmFn
     * @param {?=} abortFn
     * @param {?=} cancelFn
     * @return {?}
     */
    ConfirmationDialogComponent.prototype.handleHideEvent = /**
     * @param {?} baseComponent
     * @param {?} data
     * @param {?} reason
     * @param {?} confirmFn
     * @param {?=} abortFn
     * @param {?=} cancelFn
     * @return {?}
     */
    function (baseComponent, data, reason, confirmFn, abortFn, cancelFn) {
        if (this.action === 'confirm') {
            confirmFn(baseComponent, data, reason);
        }
        else if (this.action === 'abort') {
            // clicked the abort action button of the modal
            if (abortFn) {
                abortFn(baseComponent, data, reason);
            }
        }
        else {
            // canceled action
            if (cancelFn) {
                cancelFn(baseComponent, data, reason);
            }
            logger.debug('confirmation canceled');
        }
        // reset action
        this.action = null;
    };
    /**
     * @return {?}
     */
    ConfirmationDialogComponent.prototype.getConfirmClass = /**
     * @return {?}
     */
    function () {
        return {
            'confirm-danger': (this.confirmMode === 'danger'),
            'confirm-success': (this.confirmMode === 'success')
        };
    };
    ConfirmationDialogComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-confirmation-dialog',
                    template: "<div class=\"container-fluid\">\n  <div class=\"row\">\n    <div class=\"col-lg-12 confirmation-question\">\n      <h1 translate>global.components.confirmation-dialog.title</h1>\n      <p>{{ question }}</p>\n    </div>\n  </div>\n  <div class=\"row button-row\">\n    <div class=\"col-lg-6 button-field\">\n        <div class=\"btn\" [ngClass]=\"getConfirmClass()\" (click)=\"confirm()\">\n          <s2a-svg-icon path=\"global/actions/\" name=\"{{ confirmIconName }}\" class=\"confirmationButton\"></s2a-svg-icon>\n          <div class=\"confirm-text\">{{ confirmText }}</div>\n        </div>\n    </div>\n    <div class=\"col-lg-6 button-field\">\n        <div class=\"btn confirm-abort\" (click)=\"decline()\">\n          <s2a-svg-icon path=\"global/actions/\" name=\"cancel\" class=\"confirmationButton\"></s2a-svg-icon>\n          <div class=\"confirm-text\">{{ 'global.abort' | translate }}</div>\n        </div>\n    </div>\n  </div>\n</div>\n",
                    styles: [":host{margin:auto;text-align:center}:host .container-fluid{padding:15px;margin:0 auto}.theme-light :host .container-fluid .row .confirmation-question{color:#fff!important}.theme-dark :host .container-fluid .row .confirmation-question{color:#fff!important}:host .container-fluid .row .confirmation-question h1{font-size:1.5rem;font-weight:700}:host .container-fluid .row .confirmation-question p{font-size:1.5rem}:host .container-fluid .row.button-row{justify-content:center}:host .container-fluid .row.button-row .button-field{flex:0 0 40%;max-width:40%}:host .container-fluid .row.button-row .button-field .btn{border-radius:0 15px;border:2px solid;width:4.375rem;height:4.375rem;padding:.25rem!important;vertical-align:middle;text-align:center!important;margin-bottom:.5rem!important}.theme-light :host .container-fluid .row.button-row .button-field .btn{border-color:#fff!important;color:#fff!important}.theme-dark :host .container-fluid .row.button-row .button-field .btn{border-color:#fff!important;color:#fff!important}:host .container-fluid .row.button-row .button-field .btn:hover{cursor:pointer}:host .container-fluid .row.button-row .button-field .btn .confirm-text{text-transform:lowercase;font-size:.875rem}.theme-light :host .container-fluid .row.button-row .button-field .btn.confirm-danger{background-color:#b3282e!important}.theme-dark :host .container-fluid .row.button-row .button-field .btn.confirm-danger{background-color:#b3282e!important}@media print{.theme-dark :host .container-fluid .row .confirmation-question{color:#fff!important}.theme-dark :host .container-fluid .row.button-row .button-field .btn{border-color:#fff!important;color:#fff!important}.theme-dark :host .container-fluid .row.button-row .button-field .btn.confirm-danger{background-color:#b3282e!important}.theme-dark :host .container-fluid .row.button-row .button-field .btn.confirm-success{background-color:#fd0!important}}.theme-light :host .container-fluid .row.button-row .button-field .btn.confirm-success{background-color:#fd0!important}.theme-dark :host .container-fluid .row.button-row .button-field .btn.confirm-success{background-color:#fd0!important}:host .container-fluid .row.button-row .button-field .btn.confirm-abort{background:linear-gradient(-135deg,#4cd8f9 -40%,#2f77bb 100%)!important}"]
                }] }
    ];
    /** @nocollapse */
    ConfirmationDialogComponent.ctorParameters = function () { return [
        { type: BsModalRef }
    ]; };
    return ConfirmationDialogComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var DropdownComponent = /** @class */ (function () {
    function DropdownComponent() {
        this.isLoading = false;
        this.preSelectString = '--';
        this.menuHeight = '';
        this.required = false;
        this.selectionChanged = new EventEmitter();
    }
    /**
     * @return {?}
     */
    DropdownComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @return {?}
     */
    DropdownComponent.prototype.isInvalid = /**
     * @return {?}
     */
    function () {
        if (!this.required) {
            return false;
        }
        return this.selectedItemId === undefined || this.selectedItemId === this.preSelectString;
    };
    /**
     * @return {?}
     */
    DropdownComponent.prototype.getMenuHeight = /**
     * @return {?}
     */
    function () {
        return {
            'menuheight-large': (this.menuHeight === 'large'),
            'menuheight-small': (this.menuHeight === 'small')
        };
    };
    /**
     * @param {?} changes
     * @return {?}
     */
    DropdownComponent.prototype.ngOnChanges = /**
     * @param {?} changes
     * @return {?}
     */
    function (changes) {
        if ('data' in changes && changes['data'].currentValue) {
            this.dataMap = changes['data'].currentValue
                .reduce(function (dataMap, currentItem) {
                dataMap[currentItem[0]] = currentItem[1];
                return dataMap;
            }, {});
        }
    };
    /**
     * @param {?} itemId
     * @return {?}
     */
    DropdownComponent.prototype.selectedItemChanged = /**
     * @param {?} itemId
     * @return {?}
     */
    function (itemId) {
        this.selectedItemId = itemId;
        this.selectionChanged.emit(itemId);
    };
    DropdownComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-dropdown',
                    template: "<div class=\"btn-group\" dropdown [isDisabled]=\"isDisabled\" [class.invalid]='isInvalid()'>\n  <div *ngIf=\"!isLoading\">\n    <button id=\"button-basic\" dropdownToggle type=\"button\" class=\"btn btn-dropdown dropdown-toggle\"\n            aria-controls=\"dropdown-basic\">\n          <div class=\"dropdown-text\">\n          {{ selectedItemId && dataMap ? dataMap[selectedItemId] : preSelectString }} \n          </div>\n          <s2a-svg-icon path=\"global/actions/\" name=\"navigationArrow\" class=\"dropdownButton\" ></s2a-svg-icon>\n    </button>\n    <ul id=\"dropdown-basic\" *dropdownMenu class=\"dropdown-menu\" [ngClass]=\"getMenuHeight()\"\n        role=\"menu\" aria-labelledby=\"button-basic\">\n      <li role=\"menuitem\" *ngFor=\"let item of data\" (click)=\"selectedItemChanged(item[0])\" class=\"pointer\">\n        <div class=\"dropdown-item\">\n          {{ item[1] }}\n        </div>\n      </li>\n    </ul>\n  </div>\n  <div *ngIf=\"isLoading\">\n      <button type=\"button\" class=\"btn btn-dropdown dropdown-toggle\">\n        <s2a-spinner></s2a-spinner>\n      </button>\n  </div>\n</div>",
                    styles: [".theme-light :host .boxed{background-color:#fff!important}.theme-dark :host .boxed{background-color:#2b496b!important}.pointer{cursor:pointer}:host .btn.btn-dropdown,:host .btn.btn-dropdown:not([href]):not([tabindex]){border:2px solid;border-radius:0 15px;position:relative;width:100%;height:37px;padding:.25rem 1rem!important;font-size:1.125rem;font-weight:lighter;text-align:left}.theme-light :host .btn.btn-dropdown,.theme-light :host .btn.btn-dropdown:not([href]):not([tabindex]){color:#525252!important;background-color:#f7f7f7!important;border-color:#e0e0e0!important}.theme-dark :host .btn.btn-dropdown,.theme-dark :host .btn.btn-dropdown:not([href]):not([tabindex]){color:#fff!important;background-color:#193a61!important;border-color:#405b7c!important}:host .btn.btn-dropdown s2a-svg-icon,:host .btn.btn-dropdown:not([href]):not([tabindex]) s2a-svg-icon{position:absolute;top:0;right:15px;width:24px;height:24px;-webkit-transform:rotate(0);transform:rotate(0);transition:.1s linear}:host .btn.btn-dropdown .dropdown-text,:host .btn.btn-dropdown:not([href]):not([tabindex]) .dropdown-text{width:95%;overflow-x:hidden;text-overflow:ellipsis}:host .btn.btn-dropdown:after,:host .btn.btn-dropdown:not([href]):not([tabindex]):after{display:none!important}:host .btn.btn-dropdown:focus,:host .btn.btn-dropdown:not([href]):not([tabindex]):focus{box-shadow:0 0 0 0 transparent}:host ul.menuheight-small{overflow-y:scroll;max-height:150px}:host ul.menuheight-large{overflow-y:scroll;max-height:300px}:host ul.dropdown-menu{padding:0!important;min-width:4.375rem!important;width:100%;top:.7em!important;z-index:1004!important;border:0;border-radius:0;box-shadow:none}.theme-light :host ul.dropdown-menu{background:#fff!important}.theme-dark :host ul.dropdown-menu{background:#142e4d!important}:host ul.dropdown-menu li{height:2.313rem}:host ul.dropdown-menu li.dropdown-section{padding-top:3rem!important;padding-bottom:1.5rem!important}:host ul.dropdown-menu li .dropdown-item{height:2.313rem;min-width:4.375rem;padding:.5rem 1rem!important;font-size:1.125rem;font-weight:lighter;line-height:1.25rem;clear:both;cursor:pointer}.theme-light :host ul.dropdown-menu li .dropdown-item{color:#525252!important}.theme-dark :host ul.dropdown-menu li .dropdown-item{color:#fff!important}:host ul.dropdown-menu li .dropdown-item:hover{background-image:linear-gradient(-135deg,#50bee4 0,#2874ba 100%)!important}.theme-light :host ul.dropdown-menu li .dropdown-item:hover{color:#fff!important}.theme-dark :host ul.dropdown-menu li .dropdown-item:hover{color:#fff!important}@media print{.theme-dark :host .boxed{background-color:#fff!important}.theme-dark :host .btn.btn-dropdown,.theme-dark :host .btn.btn-dropdown:not([href]):not([tabindex]){color:#525252!important;background-color:#f7f7f7!important;border-color:#e0e0e0!important}.theme-dark :host ul.dropdown-menu{background:#fff!important}.theme-dark :host ul.dropdown-menu li .dropdown-item{color:#525252!important}.theme-dark :host ul.dropdown-menu li .dropdown-item:hover{color:#fff!important}}:host ul.dropdown-menu li:nth-child(1){height:60px!important}:host ul.dropdown-menu li:nth-child(1) .dropdown-item{height:60px!important;padding:2rem 1rem .5rem!important}:host.noArrow{font-weight:700}:host.noArrow .btn.btn-dropdown .dropdown-text,:host.noArrow .btn.btn-dropdown:not([href]):not([tabindex]) .dropdown-text{width:100%;overflow-x:initial}:host.noArrow .btn-group .btn.btn-dropdown{text-align:center}:host.noArrow .btn-group .btn.btn-dropdown s2a-svg-icon{display:none!important}:host.noArrow .btn-group ul.dropdown-menu li .dropdown-item{text-align:center!important}:host .btn-group.open .btn-dropdown{z-index:1060}:host .btn-group.open .btn-dropdown s2a-svg-icon{-webkit-transform:rotate(-180deg);transform:rotate(-180deg);top:12px}:host .btn-group{width:100%}:host .btn-group div{width:100%}"]
                }] }
    ];
    /** @nocollapse */
    DropdownComponent.ctorParameters = function () { return []; };
    DropdownComponent.propDecorators = {
        isLoading: [{ type: Input }],
        preSelectString: [{ type: Input }],
        data: [{ type: Input }],
        selectedItemId: [{ type: Input }],
        isDisabled: [{ type: Input }],
        menuHeight: [{ type: Input }],
        required: [{ type: Input }],
        selectionChanged: [{ type: Output }]
    };
    return DropdownComponent;
}());
/**
 * Get the label for a DropdownComponent value
 *
 * Dropdowns get lists with a list of two strings as data
 * First string is the value to select
 * Second string is the label that will be displayed in the dropdown
 *
 * @param {?} data Dataset which is passed to the dropdown component
 * @param {?} key Dataset value whose label should be found
 * @param {?=} keyNotFoundLabel Return value when key was not found
 * @return {?}
 */
function getDropdownLabel(data, key, keyNotFoundLabel) {
    if (keyNotFoundLabel === void 0) { keyNotFoundLabel = ''; }
    var e_1, _a;
    try {
        for (var data_1 = __values(data), data_1_1 = data_1.next(); !data_1_1.done; data_1_1 = data_1.next()) {
            var values = data_1_1.value;
            if (values[0] === key) {
                return values[1];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (data_1_1 && !data_1_1.done && (_a = data_1.return)) _a.call(data_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return keyNotFoundLabel;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var S2ANotificationService = /** @class */ (function () {
    function S2ANotificationService(service) {
        this.service = service;
        this.type = 'info';
        this.position = { horizontal: 'right', vertical: 'bottom' };
        this.animation = { type: 'fade', duration: 500 };
        this.showIcon = true;
        this.hideAfter = 2000;
        this.closable = false;
    }
    /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    S2ANotificationService.prototype.info = /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    function (msg, options) {
        this.show(msg, 'info', options);
    };
    /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    S2ANotificationService.prototype.success = /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    function (msg, options) {
        this.show(msg, 'success', options);
    };
    /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    S2ANotificationService.prototype.warning = /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    function (msg, options) {
        this.show(msg, 'warning', options);
    };
    /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    S2ANotificationService.prototype.error = /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    function (msg, options) {
        this.show(msg, 'error', options);
    };
    /**
     * @param {?} msg
     * @param {?=} type
     * @param {?=} options
     * @return {?}
     */
    S2ANotificationService.prototype.show = /**
     * @param {?} msg
     * @param {?=} type
     * @param {?=} options
     * @return {?}
     */
    function (msg, type, options) {
        this.service.show({
            content: msg,
            animation: options && options.animation ? options.animation : this.animation,
            position: options && options.position ? options.position : this.position,
            type: { style: type ? type : this.type, icon: options && options.showIcon ? options.showIcon : this.showIcon },
            hideAfter: options && options.hideAfter ? options.hideAfter : this.hideAfter,
            closable: options && options.closable ? options.closable : this.closable,
        });
    };
    S2ANotificationService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    S2ANotificationService.ctorParameters = function () { return [
        { type: NotificationService }
    ]; };
    /** @nocollapse */ S2ANotificationService.ngInjectableDef = defineInjectable({ factory: function S2ANotificationService_Factory() { return new S2ANotificationService(inject(NotificationService)); }, token: S2ANotificationService, providedIn: "root" });
    return S2ANotificationService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var logger$1 = Logger('scan-qr-code-modal');
var ScanQrCodeModalComponent = /** @class */ (function (_super) {
    __extends(ScanQrCodeModalComponent, _super);
    function ScanQrCodeModalComponent(modalRef, notificationService, translateService) {
        var _this = _super.call(this, modalRef) || this;
        _this.modalRef = modalRef;
        _this.notificationService = notificationService;
        _this.translateService = translateService;
        _this.onClose = new EventEmitter();
        _this.loading = true;
        return _this;
    }
    /**
     * @return {?}
     */
    ScanQrCodeModalComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        this.loading = false;
    };
    /**
     * @param {?} url
     * @return {?}
     */
    ScanQrCodeModalComponent.prototype.scanSuccessful = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        this.closeAndReturn(url);
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ScanQrCodeModalComponent.prototype.scanFailure = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var errorMsg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger$1.error('qrscanner scan failure:', event);
                        return [4 /*yield*/, this.translateService.get('components.global.scan_qr-code.scan_failure').toPromise()];
                    case 1:
                        errorMsg = _a.sent();
                        this.notificationService.error(errorMsg);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ScanQrCodeModalComponent.prototype.scanError = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var errorMsg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger$1.error('qrscanner scan error:', event);
                        return [4 /*yield*/, this.translateService.get('components.global.scan_qr-code.scan_failure').toPromise()];
                    case 1:
                        errorMsg = _a.sent();
                        this.notificationService.error(errorMsg);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} cameras
     * @return {?}
     */
    ScanQrCodeModalComponent.prototype.camerasFound = /**
     * @param {?} cameras
     * @return {?}
     */
    function (cameras) {
        return __awaiter(this, void 0, void 0, function () {
            var backcamera;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger$1.debug('cameras found', cameras);
                        return [4 /*yield*/, this.scanner.askForPermission()];
                    case 1:
                        _a.sent();
                        backcamera = cameras.find(function (camera) { return camera.label && camera.label.match(/(back|rück|world)/ig); });
                        if (backcamera) {
                            this.scanner.scan(backcamera.deviceId);
                        }
                        else if (cameras.length) {
                            this.scanner.scan(cameras[cameras.length - 1].deviceId);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ScanQrCodeModalComponent.prototype.camerasNotFound = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var errorMsg;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger$1.debug('no cameras found', event);
                        return [4 /*yield*/, this.translateService.get('components.global.scan_qr-code.no_camera_found').toPromise()];
                    case 1:
                        errorMsg = _a.sent();
                        this.notificationService.error(errorMsg);
                        this.closeAndReturn(null);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * @param {?} url
     * @return {?}
     */
    ScanQrCodeModalComponent.prototype.closeAndReturn = /**
     * @param {?} url
     * @return {?}
     */
    function (url) {
        this.onClose.next(url);
        this.onClose.complete();
        this.modalRef.hide();
    };
    ScanQrCodeModalComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-scan-qr-code-modal',
                    template: "<s2a-modal-header [title]=\"'components.global.scan_qr-code.modal_title' | translate\" [modalRef]=\"modalRef\"></s2a-modal-header>\n<div class=\"modal-body\">\n    <ng-container>\n        <zxing-scanner #scanner [formats]=\"['QR_CODE']\"\n                       (camerasFound)=\"camerasFound($event)\"\n                       (camerasNotFound)=\"camerasNotFound($event)\"\n                       [scannerEnabled]=\"true\"\n                       (scanSuccess)=\"scanSuccessful($event)\"\n                       (scanFailure)=\"scanFailure($event)\"\n                       (scanError)=\"scanError($event)\"\n        ></zxing-scanner>\n    </ng-container>\n</div>\n\n<div class=\"modal-footer\">\n    <button class=\"btn btn-primary btn-leaf float-right\" type=\"Submit\" translate (click)=\"closeAndReturn(null)\">\n        global.close\n    </button>\n</div>\n\n",
                    styles: ["::ng-deep s2a-scan-qr-code-modal zxing-scanner{max-height:calc(100vh - 233px)}::ng-deep s2a-scan-qr-code-modal zxing-scanner video{max-height:calc(100vh - 233px);-o-object-fit:contain!important;object-fit:contain!important}"]
                }] }
    ];
    /** @nocollapse */
    ScanQrCodeModalComponent.ctorParameters = function () { return [
        { type: BsModalRef },
        { type: S2ANotificationService },
        { type: TranslateService }
    ]; };
    ScanQrCodeModalComponent.propDecorators = {
        scanner: [{ type: ViewChild, args: ['scanner',] }]
    };
    return ScanQrCodeModalComponent;
}(BaseModalPageComponent));

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var logger$2 = Logger('qr-code-service');
var QrCodeService = /** @class */ (function () {
    function QrCodeService(router, modalService) {
        this.router = router;
        this.modalService = modalService;
    }
    /**
     * @param {?} data
     * @return {?}
     */
    QrCodeService.prototype.generateAndShow = /**
     * @param {?} data
     * @return {?}
     */
    function (data) {
        /** @type {?} */
        var unit = data.equipmentPath.slice(-1)[0];
        /** @type {?} */
        var path = data.equipmentPath.slice(0, -1).join(' > ');
        /** @type {?} */
        var properties = data.properties ? data.properties.map(function (p) { return p.key + ": " + p.value; }) : [];
        /** @type {?} */
        var html = "<h1>" + unit + "</h1><p class=\"qrcode-subtitle\">" + path + "</p><div>" + properties.join('<br>') + "</div>";
        // Communication happens over local storage because otherwise the url can become too long
        localStorage["qrCodeData"] = JSON.stringify({
            url: data.url,
            html: html,
        });
        this.router.navigate(['qr-code']);
    };
    /**
     * @param {?} url
     * @param {?} title
     * @param {?} subtitle
     * @param {?=} props
     * @return {?}
     */
    QrCodeService.prototype.generateAndShowSimple = /**
     * @param {?} url
     * @param {?} title
     * @param {?} subtitle
     * @param {?=} props
     * @return {?}
     */
    function (url, title, subtitle, props) {
        /** @type {?} */
        var properties = props ? props.map(function (p) { return p.key + ": " + p.value; }) : [];
        /** @type {?} */
        var html = "<h1>" + title + "</h1><p class=\"qrcode-subtitle\">" + subtitle + "</p><div>" + properties.join('<br>') + "</div>";
        // Communication happens over local storage because otherwise the url can become too long
        localStorage["qrCodeData"] = JSON.stringify({
            url: url,
            html: html,
        });
        this.router.navigate(['qr-code']);
    };
    /**
     * @param {?=} returnRelativeUrl
     * @return {?}
     */
    QrCodeService.prototype.scan = /**
     * @param {?=} returnRelativeUrl
     * @return {?}
     */
    function (returnRelativeUrl) {
        if (returnRelativeUrl === void 0) { returnRelativeUrl = false; }
        return __awaiter(this, void 0, void 0, function () {
            var config, url, matches;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        config = {
                            class: 'modal-lg',
                        };
                        this.modalRef = this.modalService.show(ScanQrCodeModalComponent, config);
                        return [4 /*yield*/, this.modalRef.content.onClose.toPromise()];
                    case 1:
                        url = _a.sent();
                        logger$2.debug('scan qrCode Modal closed:', url);
                        if (returnRelativeUrl && url) {
                            matches = url.match(/^http(s)?:\/\/[^\/]+(.*)$/i);
                            if (Array.isArray(matches) && matches.length >= 3) {
                                // [0] is full match, [1] is match in http(s) and [2] is the match we want.
                                url = matches[2];
                            }
                        }
                        return [2 /*return*/, url];
                }
            });
        });
    };
    QrCodeService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    QrCodeService.ctorParameters = function () { return [
        { type: Router },
        { type: BsModalService }
    ]; };
    /** @nocollapse */ QrCodeService.ngInjectableDef = defineInjectable({ factory: function QrCodeService_Factory() { return new QrCodeService(inject(Router), inject(BsModalService$1)); }, token: QrCodeService, providedIn: "root" });
    return QrCodeService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var logger$3 = Logger('ScanQrCodeButtonComponent');
var ScanQrCodeButtonComponent = /** @class */ (function () {
    function ScanQrCodeButtonComponent(qrCodeService, router) {
        this.qrCodeService = qrCodeService;
        this.router = router;
        this.iconSize = 24;
    }
    /**
     * @return {?}
     */
    ScanQrCodeButtonComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    /**
     * @param {?} event
     * @return {?}
     */
    ScanQrCodeButtonComponent.prototype.scanBtnClicked = /**
     * @param {?} event
     * @return {?}
     */
    function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.qrCodeService.scan(true)];
                    case 1:
                        url = _a.sent();
                        if (url) {
                            this.router.navigate([url]);
                        }
                        else {
                            logger$3.debug('No url found or dialog closed before scan.');
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ScanQrCodeButtonComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-scan-qr-code-button',
                    template: "<a style=\"cursor: pointer;\" (click)=\"scanBtnClicked($event)\">\n    <s2a-svg-icon path=\"global/actions/\" name=\"qrIcon\"></s2a-svg-icon>\n</a>",
                    styles: [".scanButton:hover{cursor:pointer}.theme-light .scanButton:hover{background-color:#f7f7f7}.theme-dark .scanButton:hover{background-color:#1a395f}@media print{.theme-dark .scanButton:hover{background-color:#f7f7f7}}"]
                }] }
    ];
    /** @nocollapse */
    ScanQrCodeButtonComponent.ctorParameters = function () { return [
        { type: QrCodeService },
        { type: Router }
    ]; };
    ScanQrCodeButtonComponent.propDecorators = {
        iconSize: [{ type: Input }]
    };
    return ScanQrCodeButtonComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var EXCEL_EXTENSION = '.xlsx';
var ExcelService = /** @class */ (function () {
    function ExcelService() {
        this.workBook = utils.book_new();
    }
    /**
     * Save an JSON object to a new sheet.
     * @param {?} json JSON object
     * @param {?} sheetName Name of current sheet
     * @return {?}
     */
    ExcelService.prototype.addJSONToNewSheet = /**
     * Save an JSON object to a new sheet.
     * @param {?} json JSON object
     * @param {?} sheetName Name of current sheet
     * @return {?}
     */
    function (json, sheetName) {
        if (!this.workBook.SheetNames.includes(sheetName) && json.length > 0) {
            /** @type {?} */
            var workSheet = utils.json_to_sheet(json);
            utils.book_append_sheet(this.workBook, workSheet, sheetName);
        }
    };
    /**
     * Return workbook object.
     * @return {?}
     */
    ExcelService.prototype.getWorkBook = /**
     * Return workbook object.
     * @return {?}
     */
    function () {
        return this.workBook;
    };
    /**
     * Create EXCEL file with all added sheets.
     * @param {?} fileName file name
     * @return {?}
     */
    ExcelService.prototype.saveAsExcelFile = /**
     * Create EXCEL file with all added sheets.
     * @param {?} fileName file name
     * @return {?}
     */
    function (fileName) {
        writeFile(this.workBook, fileName + EXCEL_EXTENSION);
        this.workBook = utils.book_new();
    };
    ExcelService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ExcelService.ctorParameters = function () { return []; };
    return ExcelService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var ViewportWarningComponent = /** @class */ (function () {
    function ViewportWarningComponent() {
    }
    /**
     * @return {?}
     */
    ViewportWarningComponent.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
    };
    ViewportWarningComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-viewport-warning',
                    template: "<div class=\"mt-5 container-fluid\">\n  <div class=\"row justify-content-center\">\n    <div class=\"col-6 alert alert-warning\">\n      <h3>{{ 'global.components.viewport.warning_headline' | translate }}</h3>\n      <h4>\n       {{ pageName }} {{'global.components.viewport.warning_text' | translate: {resolution:resolution} }}</h4>\n    </div>\n  </div>\n</div>",
                    styles: [""]
                }] }
    ];
    /** @nocollapse */
    ViewportWarningComponent.ctorParameters = function () { return []; };
    ViewportWarningComponent.propDecorators = {
        pageName: [{ type: Input }],
        resolution: [{ type: Input }]
    };
    return ViewportWarningComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var logger$4 = Logger('action-on-visible');
var ActionOnVisibleDirective = /** @class */ (function () {
    function ActionOnVisibleDirective(elem) {
        /**
         * Function callback for state changes.
         */
        this.stateChange = new EventEmitter();
        /**
         * Internal state of the element.
         */
        this.state = 'hidden';
        this.moreBtnElement = elem;
        logger$4.debug('ActionOnVisibleDirective initialized for:', elem);
    }
    /**
     * @return {?}
     */
    ActionOnVisibleDirective.prototype.ngOnInit = /**
     * @return {?}
     */
    function () {
        if (!this.s2aActionOnVisible) {
            logger$4.debug('No parent container set, using window');
            this.s2aActionOnVisible = window;
        }
        fromEvent(this.s2aActionOnVisible, 'scroll').subscribe(this.handleScroll.bind(this));
    };
    /**
     * @return {?}
     */
    ActionOnVisibleDirective.prototype.handleScroll = /**
     * @return {?}
     */
    function () {
        /** @type {?} */
        var viewPortHeight;
        /** @type {?} */
        var scrollTop;
        if (this.s2aActionOnVisible === window) {
            viewPortHeight = this.s2aActionOnVisible.innerHeight;
            scrollTop = this.s2aActionOnVisible.scrollY;
        }
        else {
            viewPortHeight = this.s2aActionOnVisible.clientHeight;
            scrollTop = this.s2aActionOnVisible.scrollTop;
        }
        /** @type {?} */
        var elValFromTop = this.moreBtnElement.nativeElement.offsetTop;
        if ((viewPortHeight + scrollTop) > elValFromTop) {
            if (this.state === 'hidden') {
                logger$4.info('Element got visible:', this.moreBtnElement);
                this.state = 'visible';
                this.stateChange.emit({ newValue: true, oldValue: false });
            }
        }
        else {
            if (this.state === 'visible') {
                logger$4.info('Element got hidden:', this.moreBtnElement);
                this.state = 'hidden';
                this.stateChange.emit({ newValue: false, oldValue: true });
            }
        }
    };
    ActionOnVisibleDirective.decorators = [
        { type: Directive, args: [{
                    selector: '[s2aActionOnVisible]'
                },] }
    ];
    /** @nocollapse */
    ActionOnVisibleDirective.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    ActionOnVisibleDirective.propDecorators = {
        s2aActionOnVisible: [{ type: Input }],
        stateChange: [{ type: Output }]
    };
    return ActionOnVisibleDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var NgCommonModule = /** @class */ (function () {
    function NgCommonModule() {
    }
    /**
     * @param {?=} environment
     * @return {?}
     */
    NgCommonModule.forRoot = /**
     * @param {?=} environment
     * @return {?}
     */
    function (environment) {
        if (environment === void 0) { environment = /** @type {?} */ ({}); }
        return {
            ngModule: NgCommonModule,
            providers: [
                LocalStorageService,
                TranslateHelperService,
                MomentJsDurationService,
                CacheInterceptorService,
                ThemeService,
                LunchlistService,
                IconHelperService,
                S2ANotificationService,
                QrCodeService,
                {
                    provide: S2AHttpClient,
                    useFactory: S2AHttpClientCreator,
                    deps: [HttpClient, Environment]
                },
                {
                    provide: Environment,
                    useValue: environment
                },
                ExcelService
            ]
        };
    };
    NgCommonModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        AngularSvgIconModule,
                        TranslateModule,
                        BsDropdownModule.forRoot(),
                        ZXingScannerModule.forRoot(),
                    ],
                    declarations: [
                        RelativeTimePipe,
                        FormatDurationPipe,
                        HashtagsPipe,
                        Nl2brPipe,
                        BasePageComponent,
                        BaseModalPageComponent,
                        BaseModalErrorComponent,
                        BaseSubscriptionsPageComponent,
                        LanguageSelectionComponent,
                        ModalHeaderComponent,
                        SpinnerComponent,
                        InputValidationComponent,
                        SvgIconComponent,
                        ConfirmationDialogComponent,
                        DropdownComponent,
                        ScanQrCodeButtonComponent,
                        ScanQrCodeModalComponent,
                        ViewportWarningComponent,
                        ActionOnVisibleDirective
                    ],
                    exports: [
                        RelativeTimePipe,
                        FormatDurationPipe,
                        HashtagsPipe,
                        Nl2brPipe,
                        BasePageComponent,
                        BaseModalPageComponent,
                        BaseModalErrorComponent,
                        BaseSubscriptionsPageComponent,
                        LanguageSelectionComponent,
                        ModalHeaderComponent,
                        SpinnerComponent,
                        InputValidationComponent,
                        SvgIconComponent,
                        ConfirmationDialogComponent,
                        DropdownComponent,
                        ScanQrCodeModalComponent,
                        ScanQrCodeButtonComponent,
                        ViewportWarningComponent,
                        ActionOnVisibleDirective
                    ],
                    entryComponents: [
                        ConfirmationDialogComponent,
                        ScanQrCodeModalComponent
                    ]
                },] }
    ];
    return NgCommonModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var APP_CONFIGS = [
    {
        key: 'user-management',
        type: 'Local',
        enabledByRight: 'core-user-management-list-users'
    },
    {
        key: 'incidents-reporter',
        // use a placeholder right to never show the Kachel
        enabledByRight: 'dont-enable',
        route: '/incidents/reporter'
    },
    {
        key: 'incidents',
        enabledByRight: 'questionnaire-usage',
        route: '/incidents/incidents'
    },
    {
        key: 'equipment',
        type: 'Local',
        enabledByRight: 'core-equipment-modify'
    },
    {
        key: 'insight',
        enabledByRight: 'use-site-manager'
    },
    {
        key: 'storage',
        type: 'Local',
        enabledByRight: 'storage-use-storage'
    },
    {
        key: 'maintenance',
        type: 'Local',
        enabledByRight: 'maintenance-use-maintenance'
    },
    {
        key: 'performance',
        enabledByRight: 'use-performance'
    },
    {
        key: 'lunchlist',
        type: 'Lunchlist',
        enabledByRight: 'use-lunchlist',
        route: 'https://www.syskron.com'
    },
    {
        key: 'sessions',
        type: 'External',
        enabledByRight: 'use-sessions',
        route: 'https://sessions.share2act.io/sessions/-LVxNGx5OuSzdP1gge50/'
    },
    {
        key: 'timeline',
        type: 'Local',
        enabledByRight: 'read-timeline',
        route: '/connect'
    },
    {
        key: 's2a-classic',
        type: 'Classic',
        enabledByRight: 'use-timeline'
    },
    {
        key: 'time2lubrify',
        type: 'Local',
        enabledByRight: 'maintenance-use-time2lubrify'
    },
    {
        key: 'watchdog',
        type: 'Local',
        enabledByRight: 'watchdog-usage'
    },
    {
        key: 'tickets',
        type: 'Local',
        enabledByRight: 'tickets-use-tickets'
    },
];

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @param {?} reason
 * @return {?}
 */
function isCancelledModal(reason) {
    return ['backdrop-click', 'esc', null].includes(reason);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * @param {?} a
 * @param {?} b
 * @return {?}
 */
function jsonEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
}
/**
 * @param {?} obj
 * @return {?}
 */
function removeEmpty(obj) {
    Object.entries(obj).forEach(function (_a) {
        var _b = __read(_a, 2), key = _b[0], val = _b[1];
        if (val && typeof val === 'object') {
            removeEmpty(val);
        }
        else if (val == null) {
            delete obj[key];
        }
    });
    return obj;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var logger$5 = Logger('abstractApiService');
/**
 * @abstract
 */
var AbstractApiService = /** @class */ (function () {
    function AbstractApiService(http, env, apiUrl) {
        if (env === void 0) { env = /** @type {?} */ ({}); }
        if (apiUrl === void 0) { apiUrl = ''; }
        this.http = http;
        this.env = env;
        this.apiUrl = apiUrl;
        this.apiBaseUrl = env.baseUrl + apiUrl;
    }
    /**
     * @template T
     * @param {?} endPoint
     * @param {?=} queryParams
     * @param {?=} ignoreErrors
     * @return {?}
     */
    AbstractApiService.prototype.internalGet = /**
     * @template T
     * @param {?} endPoint
     * @param {?=} queryParams
     * @param {?=} ignoreErrors
     * @return {?}
     */
    function (endPoint, queryParams, ignoreErrors) {
        var _this = this;
        if (ignoreErrors === void 0) { ignoreErrors = false; }
        logger$5.info(this.apiBaseUrl + endPoint);
        return this.http.get(this.apiBaseUrl + endPoint, {
            params: queryParams,
        })
            .pipe(map(function (response) {
            // console.log('GET response', response);
            return _this.handleSyntheticApiErrors(response);
        }), catchError(function (error) {
            // console.log('GET error', error);
            if (ignoreErrors) {
                logger$5.debug("Silent GET error:", error);
                return new Observable$1(function (subs) {
                    subs.next(null);
                    subs.complete();
                });
            }
            else {
                return throwError(error);
            }
        }));
    };
    /**
     * @template T
     * @param {?} endPoint
     * @param {?=} queryParams
     * @return {?}
     */
    AbstractApiService.prototype.internalDelete = /**
     * @template T
     * @param {?} endPoint
     * @param {?=} queryParams
     * @return {?}
     */
    function (endPoint, queryParams) {
        var _this = this;
        return this.http.delete(this.apiBaseUrl + endPoint, {
            params: queryParams,
        })
            .pipe(map(function (response) {
            // console.log('DELETE response', response);
            return _this.handleSyntheticApiErrors(response);
        }), catchError(function (error) {
            // console.log('DELETE error', error);
            return throwError(error);
        }));
    };
    /**
     * @template T
     * @param {?} endPoint
     * @param {?} payload
     * @return {?}
     */
    AbstractApiService.prototype.internalPost = /**
     * @template T
     * @param {?} endPoint
     * @param {?} payload
     * @return {?}
     */
    function (endPoint, payload) {
        var _this = this;
        return this.http.post(this.apiBaseUrl + endPoint, payload, {})
            .pipe(map(function (response) {
            // console.log('POST response', response);
            return _this.handleSyntheticApiErrors(response);
        }), catchError(function (error) {
            // console.log('POST error', error);
            return throwError(error);
        }));
    };
    /**
     * @template T
     * @param {?} endPoint
     * @param {?} payload
     * @return {?}
     */
    AbstractApiService.prototype.internalPut = /**
     * @template T
     * @param {?} endPoint
     * @param {?} payload
     * @return {?}
     */
    function (endPoint, payload) {
        var _this = this;
        return this.http.put(this.apiBaseUrl + endPoint, payload, {})
            .pipe(map(function (response) {
            // console.log('PUT response', response);
            return _this.handleSyntheticApiErrors(response);
        }), catchError(function (error) {
            // console.log('PUT error', error);
            return throwError(error);
        }));
    };
    /**
     * @template T
     * @param {?} response
     * @return {?}
     */
    AbstractApiService.prototype.handleSyntheticApiErrors = /**
     * @template T
     * @param {?} response
     * @return {?}
     */
    function (response) {
        if (response && response['errorMessage']) {
            /** @type {?} */
            var match = response['errorMessage'].match(/^\[(\d+)\]\s*(.*)/);
            if (match) {
                throw new HttpErrorResponse({
                    status: Number(match[1]),
                    statusText: match[2],
                });
            }
            else {
                throw new HttpErrorResponse({
                    status: 0,
                    statusText: response['errorMessage'],
                });
            }
        }
        return response;
    };
    /** @nocollapse */
    AbstractApiService.ctorParameters = function () { return [
        { type: HttpClient },
        { type: Environment },
        { type: String, decorators: [{ type: Inject, args: ['apiUrl',] }] }
    ]; };
    return AbstractApiService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TranslateStubDirective = /** @class */ (function () {
    function TranslateStubDirective() {
    }
    Object.defineProperty(TranslateStubDirective.prototype, "translate", {
        set: /**
         * @param {?} key
         * @return {?}
         */
        function (key) { },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TranslateStubDirective.prototype, "translateParams", {
        set: /**
         * @param {?} params
         * @return {?}
         */
        function (params) { },
        enumerable: true,
        configurable: true
    });
    TranslateStubDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector  //FIXME
                    selector: '[translate]'
                },] }
    ];
    /** @nocollapse */
    TranslateStubDirective.ctorParameters = function () { return []; };
    TranslateStubDirective.propDecorators = {
        translate: [{ type: Input }],
        translateParams: [{ type: Input }]
    };
    return TranslateStubDirective;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TranslateStubPipe = /** @class */ (function () {
    function TranslateStubPipe() {
    }
    /**
     * @param {?} value
     * @return {?}
     */
    TranslateStubPipe.prototype.transform = /**
     * @param {?} value
     * @return {?}
     */
    function (value) {
        return value;
    };
    TranslateStubPipe.decorators = [
        { type: Pipe, args: [{ name: 'translate' },] }
    ];
    return TranslateStubPipe;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TranslateStubService = /** @class */ (function () {
    function TranslateStubService() {
        this.onLangChange = new EventEmitter(true);
    }
    /**
     * @param {?} key
     * @param {?=} interpolateParams
     * @return {?}
     */
    TranslateStubService.prototype.instant = /**
     * @param {?} key
     * @param {?=} interpolateParams
     * @return {?}
     */
    function (key, interpolateParams) {
        return key;
    };
    /**
     * @param {?} key
     * @param {?=} interpolateParams
     * @return {?}
     */
    TranslateStubService.prototype.get = /**
     * @param {?} key
     * @param {?=} interpolateParams
     * @return {?}
     */
    function (key, interpolateParams) {
        return Observable.of(key);
    };
    /**
     * @param {?} key
     * @param {?=} interpolateParams
     * @return {?}
     */
    TranslateStubService.prototype.stream = /**
     * @param {?} key
     * @param {?=} interpolateParams
     * @return {?}
     */
    function (key, interpolateParams) {
        return Observable.of(key);
    };
    TranslateStubService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */
    TranslateStubService.ctorParameters = function () { return []; };
    /** @nocollapse */ TranslateStubService.ngInjectableDef = defineInjectable({ factory: function TranslateStubService_Factory() { return new TranslateStubService(); }, token: TranslateStubService, providedIn: "root" });
    return TranslateStubService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var TranslateTestingModule = /** @class */ (function () {
    function TranslateTestingModule() {
    }
    /**
     * @return {?}
     */
    TranslateTestingModule.forRoot = /**
     * @return {?}
     */
    function () {
        return {
            ngModule: TranslateTestingModule,
            providers: [
                {
                    provide: TranslateService,
                    useClass: TranslateStubService
                }
            ]
        };
    };
    TranslateTestingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule,
                    ],
                    declarations: [
                        TranslateStubPipe,
                        TranslateStubDirective
                    ],
                    exports: [
                        TranslateStubPipe,
                        TranslateStubDirective
                    ]
                },] }
    ];
    return TranslateTestingModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var DROPDOWN_STUB = 'dropdown-stub';
var DropdownStubComponent = /** @class */ (function () {
    function DropdownStubComponent() {
        this.selectedItemId = '';
        this.isLoading = false;
        this.preSelectString = '--';
        this.menuHeight = '';
        this.required = false;
    }
    DropdownStubComponent.decorators = [
        { type: Component, args: [{ selector: 's2a-dropdown', template: DROPDOWN_STUB }] }
    ];
    DropdownStubComponent.propDecorators = {
        selectedItemId: [{ type: Input }],
        isLoading: [{ type: Input }],
        preSelectString: [{ type: Input }],
        data: [{ type: Input }],
        isDisabled: [{ type: Input }],
        menuHeight: [{ type: Input }],
        required: [{ type: Input }]
    };
    return DropdownStubComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var SVG_ICON_STUB = 'svg-icon-stub';
var SvgIconStubComponent = /** @class */ (function () {
    function SvgIconStubComponent() {
        this.title = '';
    }
    SvgIconStubComponent.decorators = [
        { type: Component, args: [{
                    selector: 's2a-svg-icon',
                    template: SVG_ICON_STUB
                }] }
    ];
    SvgIconStubComponent.propDecorators = {
        path: [{ type: Input }],
        name: [{ type: Input }],
        class: [{ type: Input }],
        title: [{ type: Input }],
        svgStyle: [{ type: Input }],
        src: [{ type: Input }]
    };
    return SvgIconStubComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var S2ANotificationStubService = /** @class */ (function () {
    function S2ANotificationStubService() {
    }
    /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    S2ANotificationStubService.prototype.info = /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    function (msg, options) { };
    /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    S2ANotificationStubService.prototype.success = /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    function (msg, options) { };
    /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    S2ANotificationStubService.prototype.warning = /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    function (msg, options) { };
    /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    S2ANotificationStubService.prototype.error = /**
     * @param {?} msg
     * @param {?=} options
     * @return {?}
     */
    function (msg, options) { };
    /**
     * @param {?} msg
     * @param {?=} type
     * @param {?=} options
     * @return {?}
     */
    S2ANotificationStubService.prototype.show = /**
     * @param {?} msg
     * @param {?=} type
     * @param {?=} options
     * @return {?}
     */
    function (msg, type, options) { };
    S2ANotificationStubService.decorators = [
        { type: Injectable, args: [{
                    providedIn: 'root'
                },] }
    ];
    /** @nocollapse */ S2ANotificationStubService.ngInjectableDef = defineInjectable({ factory: function S2ANotificationStubService_Factory() { return new S2ANotificationStubService(); }, token: S2ANotificationStubService, providedIn: "root" });
    return S2ANotificationStubService;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/**
 * An ActivateRoute test double with a `paramMap` observable.
 * Use the `setParamMap()` method to add the next `paramMap` value.
 */
var  /**
 * An ActivateRoute test double with a `paramMap` observable.
 * Use the `setParamMap()` method to add the next `paramMap` value.
 */
ActivatedRouteStub = /** @class */ (function () {
    function ActivatedRouteStub(initialParams) {
        this.subject = new ReplaySubject();
        /**
         * The mock paramMap observable
         */
        this.paramMap = this.subject.asObservable();
        this.setParamMap(initialParams);
    }
    /** Set the paramMap observables's next value */
    /**
     * Set the paramMap observables's next value
     * @param {?=} params
     * @return {?}
     */
    ActivatedRouteStub.prototype.setParamMap = /**
     * Set the paramMap observables's next value
     * @param {?=} params
     * @return {?}
     */
    function (params) {
        this.subject.next(convertToParamMap(params));
    };
    return ActivatedRouteStub;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
/** @type {?} */
var PLATFORM_HEADER_STUB = 'platform-header-stub';
var PlatformHeaderStubComponent = /** @class */ (function () {
    function PlatformHeaderStubComponent() {
        this.title = '';
    }
    PlatformHeaderStubComponent.decorators = [
        { type: Component, args: [{ selector: 's2a-platform-header', template: PLATFORM_HEADER_STUB }] }
    ];
    PlatformHeaderStubComponent.propDecorators = {
        title: [{ type: Input }]
    };
    return PlatformHeaderStubComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */
var UiTestingModule = /** @class */ (function () {
    function UiTestingModule() {
    }
    UiTestingModule.decorators = [
        { type: NgModule, args: [{
                    imports: [
                        CommonModule
                    ],
                    declarations: [PlatformHeaderStubComponent, DropdownStubComponent, SvgIconStubComponent],
                    exports: [PlatformHeaderStubComponent, DropdownStubComponent, SvgIconStubComponent]
                },] }
    ];
    return UiTestingModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,uselessCode} checked by tsc
 */

export { NgCommonModule, APP_CONFIGS, HashtagsPipe, Logger, setAppInjector, AppInjector, isCancelledModal, jsonEqual, removeEmpty, MomentJsDurationService, IconHelperService, LocalStorageService, S2AHttpClientCreator, S2AHttpClient, AbstractApiService, HttpLoaderFactory, TranslateHelperService, CacheInterceptorService, LOCALSTORAGE_THEME, Theme, ThemeService, LunchlistService, S2ANotificationService, QrCodeService, ExcelService, SpinnerComponent, BasePageComponent, BaseSubscriptionsPageComponent, BaseModalPageComponent, BaseModalErrorComponent, LanguageSelectionComponent, ModalHeaderComponent, ViewportWarningComponent, InputValidationComponent, SvgIconComponent, ConfirmationDialogComponent, getDropdownLabel, DropdownComponent, ScanQrCodeButtonComponent, ScanQrCodeModalComponent, Environment, TranslateStubDirective, TranslateStubPipe, TranslateTestingModule, DROPDOWN_STUB, DropdownStubComponent, SVG_ICON_STUB, SvgIconStubComponent, S2ANotificationStubService, ActivatedRouteStub, PLATFORM_HEADER_STUB, PlatformHeaderStubComponent, UiTestingModule, ActionOnVisibleDirective, FormatDurationPipe as ɵb, Nl2brPipe as ɵc, RelativeTimePipe as ɵa };

//# sourceMappingURL=s2a-ng-common.js.map